module.exports = __webpack_public_path__ + "d9671fcda8e095300a8446fd36e32513.svg";